import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import MyDateInput from "../../app/common/form/MyDateInput";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import MyTextInput from "../../app/common/form/MyTextInput";
import { MySelectInput, valor } from "../../app/common/form/MySelectInput";
import { EstadoCivilOptions } from "../../app/common/options/EstadoCivilOptions";
import { IdentidadCulturalOptions } from "../../app/common/options/IdentidadCulturalOptions";
import {
  CCTMovimientoConsulta,
  CCTMovimientoConsultaFormValues,
} from "../../app/models/CCTMovimientoConsulta";
import "./Operaciones_style.css";
import CreateOperacion from "../Modals/CreateOperacion";
import OperacionesTabla from "./OperacionesTabla";
import { TiposDeCursos } from "../../app/common/options/TiposDeCursos";
import { TiposTransaccion } from "../../app/common/options/TiposTransaccion";
import { SubMenuOPOperaciones } from "../Operaciones/MenuOperaciones";

export default observer(function OperacionesReporte() {
  const { CCTMovimientoReporteStore, modalStore } = useStore();
  const { loadCCTMovimiento, CCTMovimientoRegistry } =
    CCTMovimientoReporteStore;
  const { CCTMovimientoByCodigo, reporte } = CCTMovimientoReporteStore;
  // CCTMovimientoRegistry.clear()

  const { loading } = CCTMovimientoReporteStore;

  const [CCTMovimientoConsulta, setSGPersona] =
    useState<CCTMovimientoConsultaFormValues>(
      new CCTMovimientoConsultaFormValues()
    );

  // useEffect(() => {
  //   if (CCTipoDeCuentaRegistry.size <= 1) {

  //     loadCCTMovimiento();

  // }
  // }, [CCTipoDeCuentaRegistry.size, loadCCTMovimiento])

  const validationSchema = Yup.object({
    fechaInicial: Yup.date().required("Obligatorio"),
  });

  function handleFormSubmit(
    CCTMovimientoConsulta: CCTMovimientoConsultaFormValues
  ) {
    // buscar

    // fecha inicial y fecha final
    if (
      CCTMovimientoConsulta.fechaInicial &&
      CCTMovimientoConsulta.fechaFinal &&
      !CCTMovimientoConsulta.tipoCuenta &&
      !CCTMovimientoConsulta.tipoMovimiento
    ) {
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: CCTMovimientoConsulta.fechaFinal,
        tipoCuenta: "",
        tipoMovimiento: "",
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
      // fecha inicial, fecha final y tipo de cuenta
    } else if (
      CCTMovimientoConsulta.fechaInicial &&
      CCTMovimientoConsulta.fechaFinal &&
      CCTMovimientoConsulta.tipoCuenta &&
      !CCTMovimientoConsulta.tipoMovimiento
    ) {
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: CCTMovimientoConsulta.fechaFinal,
        tipoCuenta: CCTMovimientoConsulta.tipoCuenta,
        tipoMovimiento: "",
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
      // fecha inicial, fecha final, tipo de cuenta y tipo de movimiento
    } else if (
      CCTMovimientoConsulta.fechaInicial &&
      CCTMovimientoConsulta.fechaFinal &&
      CCTMovimientoConsulta.tipoCuenta &&
      CCTMovimientoConsulta.tipoMovimiento
    ) {
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: CCTMovimientoConsulta.fechaFinal,
        tipoCuenta: CCTMovimientoConsulta.tipoCuenta,
        tipoMovimiento: CCTMovimientoConsulta.tipoMovimiento,
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
      // fecha inicial
    } else if (
      CCTMovimientoConsulta.fechaInicial &&
      !CCTMovimientoConsulta.fechaFinal &&
      !CCTMovimientoConsulta.tipoCuenta &&
      !CCTMovimientoConsulta.tipoMovimiento
    ) {
      // done
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: "",
        tipoCuenta: "",
        tipoMovimiento: "",
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
      //fecha inicial y tipo de cuenta
    } else if (
      CCTMovimientoConsulta.fechaInicial &&
      !CCTMovimientoConsulta.fechaFinal &&
      CCTMovimientoConsulta.tipoCuenta &&
      !CCTMovimientoConsulta.tipoMovimiento
    ) {
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: "",
        tipoCuenta: CCTMovimientoConsulta.tipoCuenta,
        tipoMovimiento: "",
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
      // fecha inicial, tipo de cuenta y tipo de transaccion
    } else if (
      CCTMovimientoConsulta.fechaInicial &&
      !CCTMovimientoConsulta.fechaFinal &&
      CCTMovimientoConsulta.tipoCuenta &&
      CCTMovimientoConsulta.tipoMovimiento
    ) {
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: "",
        tipoCuenta: CCTMovimientoConsulta.tipoCuenta,
        tipoMovimiento: CCTMovimientoConsulta.tipoMovimiento,
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
      // fecha inicial y tipo de transaccion
    } else if (
      CCTMovimientoConsulta.fechaInicial &&
      !CCTMovimientoConsulta.fechaFinal &&
      !CCTMovimientoConsulta.tipoCuenta &&
      CCTMovimientoConsulta.tipoMovimiento
    ) {
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: "",
        tipoCuenta: "",
        tipoMovimiento: CCTMovimientoConsulta.tipoMovimiento,
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
      // fecha inicial, fecha final y tipo de transaccion
    } else if (
      CCTMovimientoConsulta.fechaInicial &&
      CCTMovimientoConsulta.fechaFinal &&
      !CCTMovimientoConsulta.tipoCuenta &&
      CCTMovimientoConsulta.tipoMovimiento
    ) {
      let newCCTMovimientoConsulta: CCTMovimientoConsulta = {
        fechaInicial: CCTMovimientoConsulta.fechaInicial,
        fechaFinal: CCTMovimientoConsulta.fechaFinal,
        tipoCuenta: "",
        tipoMovimiento: CCTMovimientoConsulta.tipoMovimiento,
      };
      loadCCTMovimiento(newCCTMovimientoConsulta);
    }
  }

  return (

    <>
      <SubMenuOPOperaciones />
      
      <div>
        <div className="header_operaciones">
          <h1>Modificación de Operaciones</h1>
          <Button
            floated="right"
            icon
            positive
            size="small"
            style={{ width: "70px" }}
            onClick={() => {
              modalStore.openModal(<CreateOperacion />, 'mini');
            }}
          >
            <Icon name="add" />
          </Button>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="buscar_operaciones">
          <Formik
            validationSchema={validationSchema}
            enableReinitialize
            initialValues={CCTMovimientoConsulta}
            onSubmit={(values) => handleFormSubmit(values)}
          >
            {({ handleSubmit, isValid, isSubmitting, dirty }) => (
              <Form
                className="ui form"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <div className="form_buscar_operaciones">
                  <div>
                    <Header size="small" content="Periodo Inicial" />
                    <MyDateInput
                      name="fechaInicial"
                      placeholderText=""
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  <div>
                    <Header size="small" content="Periodo Final" />
                    <MyDateInput
                      name="fechaFinal"
                      placeholderText=""
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  <div>
                    <Header size="small" content="Tipo de Cuenta" />
                    <MySelectInput
                      id=""
                      name="tipoCuenta"
                      placeholder=" "
                      options={TiposDeCursos}
                    />
                  </div>
                  <div>
                    <Header size="small" content="Tipo de Transaccion" />
                    <MySelectInput
                      id=""
                      name="tipoMovimiento"
                      placeholder=" "
                      options={TiposTransaccion}
                    />
                  </div>
                  <div className="boton_buscar_operaciones">
                    <Button
                      loading={loading}
                      type="submit"
                      content="Buscar"
                      style={{ backgroundColor: "#15b3e8", color: "white" }}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <br></br>
        </div>
        <OperacionesTabla />
        <br></br>
        <br></br>
      </div>
    </>

  );
});
